import { PlusIcon } from 'components/shared/Icons'
import { DownloadIcon, Search } from 'lucide-react'
import { useState } from 'react'
import { SubmissionModal } from './SubmissionModal'
interface BulkSubmission {
  id: string
  uploadedAt: string
  status: 'WARNING' | 'SUCCESS'
}

const submissions: BulkSubmission[] = [
  { id: '#123456789', uploadedAt: 'March 25, 2021', status: 'WARNING' },
  { id: '#123456789', uploadedAt: 'March 25, 2021', status: 'SUCCESS' },
  { id: '#123456789', uploadedAt: 'March 25, 2021', status: 'WARNING' },
  { id: '#123456789', uploadedAt: 'March 25, 2021', status: 'WARNING' },
  { id: '#123456789', uploadedAt: 'March 25, 2021', status: 'SUCCESS' },
  { id: '#123456789', uploadedAt: 'March 25, 2021', status: 'WARNING' },
  { id: '#123456789', uploadedAt: 'March 25, 2021', status: 'SUCCESS' },
  { id: '#123456789', uploadedAt: 'March 25, 2021', status: 'SUCCESS' },
  { id: '#123456789', uploadedAt: 'March 25, 2021', status: 'WARNING' },
  { id: '#123456789', uploadedAt: 'March 25, 2021', status: 'SUCCESS' },
]

const SubmissionsTable = () => {
  const [isOpen, setOpen] = useState(false)

  return (
    <>
      {/* Header Section */}
      <div className='flex items-center justify-between mb-8 gap-4'>
        <div className='relative flex-1 max-w-md'>
          <input type='text' placeholder='Search' className='pl-10 mb-0' />
          <Search className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4' />
        </div>
        <div className='flex items-center gap-4'>
          <button className='button muted'>Guides</button>
          <button className='button muted'>
            <DownloadIcon size={14} />
            CSV Template
          </button>
          <button className='button primary' onClick={() => setOpen(true)}>
            <PlusIcon />
            Start New Submission
          </button>
        </div>
      </div>

      {/* Table Section */}
      <div className='bg-white rounded-lg shadow overflow-hidden'>
        <table className='w-full'>
          <thead className='bg-purple-50'>
            <tr>
              <th className='px-6 py-4 text-left text-sm font-medium text-purple-900'>
                ID
              </th>
              <th className='px-6 py-4 text-left text-sm font-medium text-purple-900'>
                Uploaded At
              </th>
              <th className='px-6 py-4 text-left text-sm font-medium text-purple-900'>
                Status
              </th>
            </tr>
          </thead>
          <tbody className='divide-y divide-gray-100'>
            {submissions.map((submission, index) => (
              <tr key={index} className='hover:bg-gray-50'>
                <td className='px-6 py-4'>
                  <span className='text-purple-700 font-medium'>
                    {submission.id}
                  </span>
                </td>
                <td className='px-6 py-4 text-gray-600'>{submission.uploadedAt}</td>
                <td className='px-6 py-4'>
                  <span
                    className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium
                    ${
                      submission.status === 'WARNING'
                        ? 'bg-red-100 text-red-600'
                        : 'bg-green-100 text-green-600'
                    }`}
                  >
                    {submission.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <SubmissionModal isOpen={isOpen} onClose={() => setOpen(false)} />
    </>
  )
}

export default SubmissionsTable
